jQuery(document).ready(function($){

    let buttons = $('.add-to-cart-wrapper');

    for (let i = 0; i < buttons.length; i++) {
        let button = jQuery(buttons[i]).find('.add-to-cart');
        let product_id = button.data('product_id');
        let alert = jQuery(buttons[i]).find('.add-to-cart-alert');
        button[0].addEventListener('click', function(event){
            event.preventDefault();
            jQuery.get(window.drivescout_buttons_config.shopUrl, {'action' : 'add-to-cart', 'product_id' : product_id},
                function(data, status){
                    window.location = window.drivescout_buttons_config.urls.checkout;
                    /*
                    let html = '<p>' + data.message + '</p>';
                    html += '<p><a class="checkout-button" href="'+ window.drivescout_buttons_config.urls.checkout +'">Checkout</a></p>';
                    alert[0].innerHTML  = html;
                    window.setTimeout(function(){
                        alert[0].innerHTML   = '';
                    }, 6000)
                    */
                }, 'json').fail(function(Error){
                    console.log(Error)
                    alert[0].innerHTML  = '<p>There was an error adding your product to your cart.</p>';
                    alert[0].innerHTML  = '<p>' + Error.resopnseJSON.message + '</p>';
                    window.setTimeout(function(){
                        alert[0].innerHTML   = '';
                    }, 6000)
                })
        });
    }
});